






import Vue from 'vue'
export default Vue.extend({
    computed: {
        toast(): object {
            return this.$store.getters.appToast
        }
    }
})
